module.exports = __webpack_public_path__ + "media/images/icon-scroll-horizontal-27f817acdb315be4baa0701370157a71.svg";